export default __webpack_public_path__ + "static/media/110.b2c63daa.jpg";